import { render, staticRenderFns } from "./operation-board-duty.vue?vue&type=template&id=6675f24f&scoped=true&"
import script from "./operation-board-duty.vue?vue&type=script&lang=js&"
export * from "./operation-board-duty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675f24f",
  null
  
)

export default component.exports